import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

const fetchQueueStatus = async () => {
  const { data } = await API.get("/queue_statuses");
  return data;
};

const useGetQueueStatus = () => {
  return useQuery([QUERY_KEY.GET_QUEUE_STATUS], fetchQueueStatus);
};

export default useGetQueueStatus;
